/**
 * @generated SignedSource<<69036db94789438d90933e00e22ff5b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RunDigestJobInput = {
  jobId: any;
  notificationIntegrationIds?: ReadonlyArray<any> | null | undefined;
  runDate?: number | null | undefined;
  slackChannelIds?: ReadonlyArray<string> | null | undefined;
};
export type DigestJobDetailsPageRunDigestMutation$variables = {
  input: RunDigestJobInput;
};
export type DigestJobDetailsPageRunDigestMutation$data = {
  readonly runDigestJob: {
    readonly job: {
      readonly id: any;
    };
    readonly success: boolean;
  };
};
export type DigestJobDetailsPageRunDigestMutation = {
  response: DigestJobDetailsPageRunDigestMutation$data;
  variables: DigestJobDetailsPageRunDigestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RunDigestJobPayload",
    "kind": "LinkedField",
    "name": "runDigestJob",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLJob",
        "kind": "LinkedField",
        "name": "job",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DigestJobDetailsPageRunDigestMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DigestJobDetailsPageRunDigestMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6ce8f3f280284e69457314d3f8cd8ef3",
    "id": null,
    "metadata": {},
    "name": "DigestJobDetailsPageRunDigestMutation",
    "operationKind": "mutation",
    "text": "mutation DigestJobDetailsPageRunDigestMutation(\n  $input: RunDigestJobInput!\n) {\n  runDigestJob(input: $input) {\n    success\n    job {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "047d9e4e1564b5e1eebd9b53fff64418";

export default node;
